// FLAGS: none
// What follows the active language outside React: the document's `lang` attribute, which screen readers and
// spell-checkers read, and date-fns's default locale, which every `format` call without an explicit locale uses.
// The boot applies both once i18next has resolved, then subscribes so every in-place switch re-applies them —
// the profile-language hook makes such switches happen at first load, and the in-place language switch will make
// them routine. `App` still sets the date locale once on mount; that call is now redundant, not wrong.
import { setDefaultOptions } from "date-fns";
import type { i18n as I18nInstance } from "i18next";
import { DateFnslocaleMapper } from "@src/DateLocaleSetup";

export const applyLanguageSideEffects = (language: string): void => {
  document.documentElement.lang = language;
  setDefaultOptions({ locale: DateFnslocaleMapper(language) });
};

let followed: I18nInstance | undefined;

// Subscribes once per i18next instance; a second call for the same instance is a no-op.
export const followLanguageChanges = (instance: I18nInstance): void => {
  if (followed === instance) {
    return;
  }
  instance.on("languageChanged", applyLanguageSideEffects);
  followed = instance;
};
